//Paquetes NPM de GYF.
import { Mediator } from 'com-gyf-webcore-mediator';
import { LogHelper } from 'com-gyf-webcore-loghelper';
import { Engine1Proxy, RestApiProxy, RabbitListener, SagasProxy, ConciergeProxy, LogsProxy } from 'com-gyf-webcore-servicehub';

//Exportación de constantes
export const LOGIN_START = 'LOGIN_START';
export const LOGIN_SUCCESS = 'LOGIN_SUCCESS';
export const LOGIN_FAIL = 'LOGIN_FAIL';
export const LOGIN_SET_CONFIG = 'LOGIN_SET_CONFIG';
export const ROUTE_TO_CAMBIO_CONTRASENA = 'ROUTE_TO_CAMBIO_CONTRASENA';
export const RESET_PASSAWORD_CHANGE = 'RESET_PASSAWORD_CHANGE';
export const ESCONDER_POPUP_LOGIN = 'ESCONDER_POPUP_LOGIN';

//Seteo de apiUrl
RestApiProxy.SetApiUrl();

/**
 * Action que realiza la autenticacion del usuario.
 */
export function preLogin() {
    LogHelper.In( preLogin.name );

    return ( dispatch ) => {
        dispatch( { type: LOGIN_START } );
        var authRequest = {
            "plataforma": 2
        };
        ConciergeProxy.Execute((data) => preLoginResult(data, dispatch), null, "PRELOGIN", authRequest, "SEGURIDAD");
    }
}

/**
 * Action que realiza la autenticacion del usuario.
 * @param {any} user - El usuario a autenticar.
 * @param {any} password - El password ingresado por el usuario.
 */
export function login( user, password ) {
    LogHelper.In( login.name, user, password );

    return ( dispatch, getState ) => {
        dispatch( { type: LOGIN_START } );

        var authRequest = {
            "user": user,
            "password": password,
            "plataforma": 2
        };

        ConciergeProxy.Execute( ( data ) => loginResult( data, dispatch ), null, "LOGIN", authRequest, "SEGURIDAD" );
    }
}

/**
 * Reinicia el estado del login
 */
export function reiniciarState() {
    LogHelper.In( reiniciarState.name );

    return ( dispatch ) => {
        dispatch( { type: RESET_PASSAWORD_CHANGE } );
    }
}

/**
 * Esconde popup de error.
 */
export function hidePopUp() {
    LogHelper.In( hidePopUp.name );

    return ( dispatch ) => {
        dispatch( { type: ESCONDER_POPUP_LOGIN } );
    }
}

/* --------------------------------------------- FUNCIONES AUXILIARES --------------------------------------------- */

/**
 * Callback de la ejecucion de preLogin.
 * @param {any} data - Data del callBack.
 * @param {any} dispatch - Dispatch.
 */
function preLoginResult( data, dispatch ) {
    LogHelper.In( preLoginResult.name, data, dispatch );

    let result = data.value;

    if ( result != null ) {
        if ( result.validationSuccessful == true ) {
            LogHelper.Out( preLoginResult.name, LogsProxy.SaveOperationLog, "LOGIN" );

            if (result.adGroup == null)
                result.adGroup = '';
            
            logInLogCallback( null, result.executionContext, result.userId, result.configSession, result.expirationTime, result.adGroup, dispatch );
        }
        else {
            
            if ( !result.userError ) {
                LogHelper.Out( preLoginResult.name, LOGIN_SET_CONFIG, result.configSession );
                dispatch( { type: LOGIN_SET_CONFIG, data: result.configSession, adUserLogin: result.adUserLogin } );
            }
            else {
                LogHelper.Out( preLoginResult.name, LOGIN_FAIL, result.userError );
                dispatch( { type: LOGIN_FAIL, data: result.userError } );
            }
        }
    }
}

/**
 * Callback de la ejecucion de Login.
 * @param {any} data - Data del callBack.
 * @param {any} dispatch - Dispatch.
 */
function loginResult( data, dispatch ) {
    LogHelper.In( loginResult.name, data, dispatch );

    let result = data.value;

    if ( result != null ) {
        if ( result.validationSuccessful == true ) {
            LogHelper.Out( loginResult.name, LogsProxy.SaveOperationLog, "LOGIN" );

            //LogsProxy.SaveOperationLog("SEGURIDAD,LOGIN", "Ingreso al Sistema", null, null, (data) => logInLogCallback(data, result.executionContext, result.userId, dispatch),
            //    null, null, "SEGURIDAD");
            LogsProxy.SaveOperationLog("SEGURIDAD,LOGIN", "Ingreso al sistema",
                null, null, null, null, null, "SEGURIDAD");
            logInLogCallback( null, result.executionContext, result.userId, result.configSession, result.expirationTime, result.adGroup, dispatch );
        }
        else {
            if ( result.changePassword ) {
                let params = {
                    "userId": result.userId
                };

                params = JSON.stringify( params );

                LogHelper.Out( loginResult.name, "Login", ROUTE_TO_CAMBIO_CONTRASENA, params, 'Concierge', 'SEGURIDAD' );
                dispatch( { type: ROUTE_TO_CAMBIO_CONTRASENA, data: result } );
            }
            else {
                LogHelper.Out( loginResult.name, LOGIN_FAIL, result.userError );
                dispatch( { type: LOGIN_FAIL, data: result.userError } );
            }
        }
    }
}

/**
 * 
 * @param {any} data
 * @param {any} executionContext
 * @param {any} userId
 * @param {any} configSession
 * @param {any} expirationTime
 * @param {any} dispatch
 */
function logInLogCallback( data, executionContext, userId, configSession, expirationTime, adUserGroup, dispatch ) {
    LogHelper.In( logInLogCallback.name, data, executionContext, userId, configSession, expirationTime, adUserGroup, dispatch );

    LogHelper.Out( logInLogCallback.name, LOGIN_SUCCESS, executionContext, userId, configSession, adUserGroup, expirationTime );
    dispatch( { type: LOGIN_SUCCESS, executionContext, userId, configSession, expirationTime, adUserGroup } );
}


// WEBPACK FOOTER //
// ./Portico/App/Screens/Login/actions/Actions.js